module.exports = __webpack_public_path__ + "images/wishListSwagStore-a827da0b83e48999fc1e3200c53ab94e.png";